import React, { useCallback } from 'react';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import classnames from 'classnames';
import Modal from 'components/shared/Modal/Modal';
import { VERSION_MANAGER_OPTIONS } from 'pages/AdminPage/utils';
import './AddSoftwareVersionModal.css';

export const AddSoftwareVersionModal = ({
  title,
  selectionMode,
  handleOnCloseModal,
  uploadFile,
  deviceTypes,
  fileInputRef,
  handleOnClick,
  handleDeviceTypeOnClick
}) => {
  const enableSubmitBtn = useCallback(() => {
    if (selectionMode === VERSION_MANAGER_OPTIONS.SOFTWARE) {
      return uploadFile && deviceTypes.some((deviceType) => deviceType.selected === true);
    }
    if (selectionMode === VERSION_MANAGER_OPTIONS.BEAM_TABLES) {
      return uploadFile !== null;
    }
  }, [uploadFile, deviceTypes, selectionMode]);

  return (
    <Modal
      closeTargetRef={null}
      close={handleOnCloseModal}
      animate={false}
      animateX={false}
      opaque={true}
      height={selectionMode === VERSION_MANAGER_OPTIONS.SOFTWARE ? 435 : 335}
      width={600}
    >
      <div className="AdminPage_SoftwareUploadModal">
        <div className="AdminPage_SoftwareUploadModal_UploadSoftwareVersion_Div">
          <span className="AdminPage_SoftwareUploadModal_UploadSoftwareVersion_Header">{title}</span>
          <div className="AdminPage_SoftwareUploadModal_UploadSoftwareVersion_Content">
            {uploadFile && uploadFile.name && (
              <span
                className="AdminPage_SoftwareUploadModal_UploadSoftwareVersion_FileName"
                tooltip={uploadFile && uploadFile.name}
              >
                {uploadFile && uploadFile.name}
              </span>
            )}
            <button
              className="AdminPage_SoftwareUploadModal_SelectFileButton Global_ThinBlueButton"
              onClick={() => {
                fileInputRef.current.click();
              }}
            >
              <IconAndText
                img={IconLoader.icon_upload_18}
                hoverImg={IconLoader.icon_upload_18_hover}
                text={uploadFile ? 'Select a different file' : 'Select a file'}
              />
            </button>
          </div>
        </div>

        {selectionMode === VERSION_MANAGER_OPTIONS.SOFTWARE && (
          <div className="AdminPage_SoftwareUploadModal_SelectDeviceTypes_Div">
            <span className="AdminPage_SoftwareUploadModal_SelectDeviceTypes_Header">
              Select device types that the new SW image would work with
            </span>
            <div className="AdminPage_SoftwareUploadModal_DeviceTypes_Box">
              {deviceTypes.map((deviceType, index) => {
                return (
                  <div
                    className={classnames({
                      AdminPage_SoftwareUploadModal_DeviceTypes_Item: true,
                      AdminPage_SoftwareUploadModal_DeviceTypes_Item_Selected: deviceType.selected
                    })}
                    key={index}
                    data-tip={deviceType.title}
                    onClick={() => handleDeviceTypeOnClick(index)}
                  >
                    {deviceType.title}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className="AdminPage_SoftwareUploadModal_BottomButtonsField">
          <button className="AdminPage_SoftwareUploadModal_CancelButton" onClick={handleOnCloseModal}>
            Cancel
          </button>
          <button
            className="AdminPage_SoftwareUploadModal_SubmitButton"
            type="submit"
            disabled={!enableSubmitBtn}
            onClick={handleOnClick}
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
};
